import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { SetFormatComponent } from './set-format/set-format.component';
import { Subject, from } from 'rxjs';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-c-code',
  templateUrl: './c-code.component.html',
  styleUrls: ['./c-code.component.scss']
})
export class CCodeComponent implements OnInit {
  StatusList = [{ "value": "-1", "label": "All" }, { "value": "1", "label": "Active" }, { "value": "0", "label": "Inactive" }];
  FeaturesList = [{ "value": "", "label": "All" }, { "value": "201,401", "label": "All Applications" }, { "value": "203,403", "label": "Registraions" }];

  columnDefs;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  Tempoperations: { name: string; id: string; }[];
  Tempoperations1: { name: string; id: string; }[];
  modules: any = [];
  collapesedOrNot: boolean;
  codeForm = new UntypedFormGroup({
    MODULE_ID: new UntypedFormControl(""),
    FEATURENAME: new UntypedFormControl(""),
    Status: new UntypedFormControl("-1"),
    NAME: new UntypedFormControl("")
  });

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.collapesedOrNot = false;
    this.columnDefs = [
      {
        "headerName": "Name",
        "field": "NAME",
      },
      {
        "headerName": "Program",
        "field": "ModuleName",
      },
      {
        "headerName": "Feature name",
        "field": "FeatureName"
      },
      /*  {
         "headerName": "Enabled",
         "field": "Enabled"
       }, */
      {
        "headerName": "Format",
        "field": "CodeFormat"
      }
      ,
      {
        "headerName": "Status",
        "field": "Status"
      }

    ];
    this.setSummary();
  }
  setRowOperations(rowData: any[])
  {
   
    this.Tempoperations = [];
    let hasAdd=this.commonService.getScreenPermission("620", "N");
    let hasEdit=this.commonService.getScreenPermission("620", "E");
    let hasDelete=this.commonService.getScreenPermission("620", "D");
    rowData.forEach(element => {
      this.Tempoperations1 = [];
      
  
      if (element.FeatureName == "All Applications") {
        if (hasEdit) {
          this.Tempoperations1.push({
            "name": "Edit",
            "id": "Edit"
          });
        }
        if (hasDelete) {
          this.Tempoperations1.push({
                "name": "Delete",
                "id": "delete"
              });
        }

      }
      if(element.FeatureName == "Registrations"){
        if(hasEdit) {
          this.Tempoperations1.push({
            "name": "Edit",
            "id": "Edit"
          });

        }
      }
     
        element["Operations"] = this.Tempoperations1.map(operation => {
          return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      
    });

        if (hasAdd) {
      this.Tempoperations.push({
        "name": "Add ID Format",
        "id": "add"
      });
     }
    this.operations = this.Tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
   
    return rowData;
  }
  
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  getModules() {
    this.summaryService.getModuleByOrgId('api/common/getautocodemodules').subscribe((result) => {
      this.modules = result;
      this.modules.push({
        NAME: "All", ID: "", checked: true
      })
    });
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  add(RcordData: any) {
    

    let modalRef = this['self'].modalService.open(SetFormatComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content =
      {
        id: "",
        program: "",
        feature: "",
        heading: "Add"
      }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }

  Edit(RcordData: any) {
    let modalRef = this['self'].modalService.open(SetFormatComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });

    modalRef.componentInstance.Content =
      {
        // heading: 'Add',p
        // content:

        id: RcordData['ID'],
        program: RcordData['ModuleName'],
        feature: RcordData['FeatureName'],
        heading: "Edit"
      }
    modalRef.result.then((result) => {
      this['self'].setSummary();
    });
  }


  delete(record) {
    const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false})
    modalRef.componentInstance.Content = { heading: 'Delete', custommessage: 'Are you sure you want to delete this ID Format '+ "'" +record.NAME + "'" +' ?',ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
        modalRef.result.then(result => {
        if(result=="okclick")
        {
          this['self'].summaryService.Delete('api/autocode/delete?config=' +  record.ID).subscribe(result => {
            if (result.Status === 0) {             
              this['self'].commonService.SuccessBanner(result.Message);
              this['self'].setSummary();
            }
            else {
              this['self'].commonService.ValidationBanner(result.Message);
            }
          });
        }
      }); 
  };

  setSummary() {
    this.summaryService.getCCodeSummary().subscribe(summary => {
      this.rowData = summary;
      this.rowData = this.setRowOperations(this.rowData);
    });
  }
  setSearchSummary(formData) {
    this.summaryService.getAutoCodeSearchSummary(formData).subscribe(summary => {
      this.rowData = summary;
    });
  }

  // setSearch() {
  //   this.SearchClear();
  //   this.summaryService.getAutoCodeSearchSummary(this.codeForm.value).subscribe(summary => {
  //     this.rowData = summary;
  //   });
  // }

  //// Advace search Functions
  SearchClear() {
    this.codeForm = new UntypedFormGroup({
      MODULE_ID: new UntypedFormControl(""),
      FEATURENAME: new UntypedFormControl(""),
      Status: new UntypedFormControl("-1"),
      NAME: new UntypedFormControl("")
    });
  }

  AdvanceSearch() {
    this.setSearchSummary(this.codeForm.value);
  }

}

